import { motion, AnimatePresence } from 'framer-motion';
import { NavLink } from 'react-router';

const SIDEBAR_WIDTH = '250px';

interface NavItem {
  name: string;
  href: string;
}

const NAV_ITEMS: NavItem[] = [
  { name: 'Dashboard', href: '/members_portal/dashboard' },
  { name: 'Settings', href: '/members_portal/settings' },
  // { name: 'Logout', href: '/members_portal/logout' },
];

interface SidebarProps {
  isOpen: boolean;
  isDesktop: boolean;
  toggleSidebar: () => void;
  width?: string;
}

interface SidebarNavProps {
  items: NavItem[];
}

// A dynamic SidebarNav that maps over nav items.
const SidebarNav: React.FC<SidebarNavProps> = ({ items }) => (
  <nav className="flex flex-col space-y-2">
    {items.map((item) => (
      <NavLink key={item.href} to={item.href} className="p-2 rounded hover:bg-paper">
        {item.name.toUpperCase()}
      </NavLink>
    ))}
  </nav>
);

export default function Sidebar({ isOpen, isDesktop, toggleSidebar }: SidebarProps) {
  if (isDesktop) {
    return (
      <motion.aside
        initial={false}
        animate={{ width: isOpen ? SIDEBAR_WIDTH : '0px' }}
        transition={{ type: 'tween', duration: 0.3 }}
        className="bg-cream text-ashgray overflow-hidden"
      >
        <div className="h-full flex flex-col p-4">
          <div className="text-lg font-bold mb-4">Logo</div>
          <SidebarNav items={NAV_ITEMS} />
        </div>
      </motion.aside>
    );
  }

  // Mobile version: render an overlay and a sliding sidebar.
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Overlay to close sidebar when clicking outside */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 bg-black z-40"
            onClick={toggleSidebar}
          />
          <motion.aside
            initial={{ x: '-100%' }}
            animate={{ x: 0 }}
            exit={{ x: '-100%' }}
            transition={{ type: 'tween', duration: 0.3 }}
            className="fixed inset-y-0 left-0 w-[250px] bg-cream text-white z-50"
          >
            <div className="h-full flex flex-col p-4">
              {/* Add margin to push the logo down under the hamburger */}
              <div className="text-lg font-bold mt-12 mb-4">Logo</div>
              <SidebarNav items={NAV_ITEMS} />
            </div>
          </motion.aside>
        </>
      )}
    </AnimatePresence>
  );
}
